// @vendors
const get = require('lodash/object/get');

// @core
const apiURLBuilder = require('core/apiURLBuilder');

// @utilities
const { APIGet } = require('utilities/APIRequestHelper');

// @constants
const actionTypes = require('constants/actionTypes');

const fetchAditionalInformationSuccess = (operationIndex, response) => dispatch =>
    dispatch({
        type:
            actionTypes.BROKER_CORPORATES_OPERATIONS_CONTRACT_OPERATION_FETCH_ADDITIONAL_INFORMATION_SUCCESS,
        payload: {
            operationIndex,
            response
        }
    });

const fetchAditionalInformationError = (operationIndex, error) => dispatch =>
    dispatch({
        type:
            actionTypes.BROKER_CORPORATES_OPERATIONS_CONTRACT_OPERATION_FETCH_ADDITIONAL_INFORMATION_ERROR,
        payload: {
            operationIndex,
            error
        }
    });


const fetchAditionalInformation = (operationIndex, browsingLanguage) => (dispatch, getState) => {
    const immCorporativeOperation = getState().brokerCorporatesOperations.getIn([
        'selectedContract',
        'operations',
        operationIndex
    ]);
    const contract = getState().brokerCorporatesOperations.getIn(['selectedContract', 'contract']);

    if (
        !immCorporativeOperation ||
        immCorporativeOperation.get('fetchingAdditionalInformation') ||
        immCorporativeOperation.get('fetchedAdditionalInformation')
    ) {
        return;
    }

    dispatch({
        type:
            actionTypes.BROKER_CORPORATES_OPERATIONS_CONTRACT_OPERATION_FETCH_ADDITIONAL_INFORMATION,
        payload: { operationIndex }
    });
    const query = { id: immCorporativeOperation.get('linkId') };

    const requestData = {
        query: {
            producto: contract.get('product'),
            numeroContrato: contract.get('number'),
            fechaInicioOperacion: immCorporativeOperation.get('startDate'),
            language: browsingLanguage
        }
    };

    APIGet(
        dispatch,
        apiURLBuilder.getURL('brokerFinancialOperationsDetails', query),
        requestData
    ).then(
        response => dispatch(fetchAditionalInformationSuccess(operationIndex, response)),
        error => dispatch(fetchAditionalInformationError(operationIndex, error))
    );
};

function reset() {
    return {
        type: actionTypes.BROKER_CORPORATES_OPERATIONS_RESET
    };
}

function changeStocksContractValue(value) {
    return {
        type: actionTypes.BROKER_CORPORATES_OPERATIONS_STOCK_CONTRACT_CHANGED,
        payload: {
            value
        }
    };
}

function requestContractOperationsRequest() {
    return {
        type: actionTypes.BROKER_CORPORATES_OPERATIONS_CONTRACT_OPERATIONS_REQUEST
    };
}

function requestContractOperationsSuccess(contractOperations) {
    return {
        type: actionTypes.BROKER_CORPORATES_OPERATIONS_CONTRACT_OPERATIONS_SUCCESS,
        payload: {
            contractOperations
        }
    };
}

function requestContractOperationsFailure(error) {
    return {
        type: actionTypes.BROKER_CORPORATES_OPERATIONS_CONTRACT_OPERATIONS_FAILURE,
        payload: {
            error
        }
    };
}

const requestSelectedContractOperations = () => (dispatch, getState) => {
    const immCorporatesOperations = get(getState(), 'brokerCorporatesOperations');
    const selectedContract = immCorporatesOperations.get('selectedContract');

    if (!selectedContract) {
        return;
    }

    const requestData = {
        query: {
            producto: selectedContract.getIn(['contract', 'product']),
            numeroContrato: selectedContract.getIn(['contract', 'number'])
        }
    };

    dispatch(requestContractOperationsRequest());

    return APIGet(dispatch, apiURLBuilder.getURL('brokerFinancialOperations'), requestData)
        .then(response => {
            dispatch(requestContractOperationsSuccess(response));
        })
        .catch(response => {
            dispatch(requestContractOperationsFailure(get(response, 'error')));
        });
};

module.exports = {
    fetchAditionalInformation,
    changeStocksContractValue,
    requestSelectedContractOperations,
    reset
};
